import {useState, useRef, useEffect} from 'react';
import MultiSelect from './widgets/MultiSelect';
import TimeSlider from './widgets/TimeSlider';
import MapStyleSelect from './widgets/MapStyleSelect';

function Sidebar(props) {

	const sliderContainerRef = useRef(null);
	const [sliderContainerWidth, setSliderContainerWidth] = useState(0);
	const [timeSliderDisabled, setTimeSliderDisabled] = useState(false);

	useEffect(() => {
	    if (sliderContainerRef.current) {
	      setSliderContainerWidth(sliderContainerRef.current.getBoundingClientRect().width)
	    }
	}, [sliderContainerRef]);

	return (
		<div className="w-full flex flex-col h-full justify-between mb-4">
			<div>
				<div>
					<MultiSelect multiSelectFilter={props.multiSelectFilter} setMultiSelectFilter={props.setMultiSelectFilter} options={props.familyOptions} filterProperty="family_id" filterFieldName="name" filterTitle="Family" />

					<p className="text-xs">{props.featureProperties}</p>
				</div>
				<MapStyleSelect mapType={props.mapType} setMapType={props.setMapType}  setTimeSliderDisabled={setTimeSliderDisabled}/>
			</div>
			<div className="w-full" ref={sliderContainerRef}>
			  <TimeSlider dateRange={props.dateRange} startDate={props.startDate} endDate={props.endDate} setStartDate={props.setStartDate} setEndDate={props.setEndDate} width={sliderContainerWidth} timeSliderDisabled={timeSliderDisabled} />
			</div>
		</div>
	)
}

export default Sidebar;